import api from "../apis/AiPastSessionsApi";

export const ListAiPastSessions =
  (data, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .list(data)
      .then((res) => {
        // Handle multiple possible response shapes:
        // 1) { data: { result: [], pagination: { totalItems, ... } } }
        // 2) { data: { sessions: [], pagination: ... } }
        // 3) { total, page, limit, data: [] }  (top-level pagination)
        // 4) [] directly
        const body = res?.data;
        const nested = body?.data;

        const list = Array.isArray(body)
          ? body
          : Array.isArray(nested)
          ? nested
          : nested?.result ??
            nested?.sessions ??
            nested?.data ??
            body?.result ??
            body?.sessions ??
            body?.data ??
            [];

        const pagination =
          nested?.pagination ??
          body?.pagination ??
          (typeof body?.total === "number" || typeof body?.totalPages === "number"
            ? {
                page: body?.page,
                limit: body?.limit,
                totalItems: body?.total,
                totalPages: body?.totalPages,
                hasNextPage: body?.hasNextPage,
                hasPrevPage: body?.hasPrevPage,
              }
            : null);

        onSuccess?.({ list, pagination });
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to fetch AI past sessions";
        onError?.(msg);
      });
  };

export const CreateOrEditAiPastSession =
  (data, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .createOrEdit(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to save AI past session";
        onError?.(msg);
      });
  };

const extractListPayload = (res) => {
  const body = res?.data;
  const nested = body?.data;

  const list = Array.isArray(body)
    ? body
    : Array.isArray(nested)
    ? nested
    : nested?.result ??
      nested?.queries ??
      nested?.sessions ??
      nested?.data ??
      body?.result ??
      body?.queries ??
      body?.sessions ??
      body?.data ??
      [];

  const pagination =
    nested?.pagination ??
    body?.pagination ??
    (typeof body?.total === "number" || typeof body?.totalPages === "number"
      ? {
          page: body?.page,
          limit: body?.limit,
          totalItems: body?.total,
          totalPages: body?.totalPages,
          hasNextPage: body?.hasNextPage,
          hasPrevPage: body?.hasPrevPage,
        }
      : null);

  return { list: Array.isArray(list) ? list : [], pagination };
};

const extractPendingCount = (res) => {
  const body = res?.data;
  const nested = body?.data;
  const candidates = [
    body?.count,
    body?.pendingCount,
    body?.pending,
    nested?.count,
    nested?.pendingCount,
    nested?.pending,
    typeof nested === "number" ? nested : undefined,
    typeof body === "number" ? body : undefined,
  ];
  const found = candidates.find((value) => typeof value === "number");
  return found ?? 0;
};

export const publishPendingQueryCount = (count) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("ai-query-pending-count", { detail: count })
  );
};

export const ListLearnerQueries =
  (data, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .listQueries(data)
      .then((res) => {
        onSuccess?.(extractListPayload(res));
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to fetch learner queries";
        onError?.(msg);
      });
  };

export const ReplyLearnerQuery =
  (data, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .replyQuery(data)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to reply to query";
        onError?.(msg);
      });
  };

export const UpdateQueryVisibility =
  (id, isPublic, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .updateQueryVisibility(id, { isPublic })
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to update query visibility";
        onError?.(msg);
      });
  };

export const GetPendingQueryCount =
  (onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .pendingQueryCount()
      .then((res) => {
        const count = extractPendingCount(res);
        publishPendingQueryCount(count);
        onSuccess?.(count);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to fetch pending query count";
        onError?.(msg);
      });
  };

export const DeleteAiPastSession =
  (id, onSuccess, onError) => (dispatch) => {
    api
      .AiPastSessionsApi()
      .delete(id)
      .then((res) => {
        onSuccess?.(res?.data);
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to delete AI past session";
        onError?.(msg);
      });
  };

